import Link from 'next/link'

import { RADIUS, SURFACE } from '@/lib/surface'
import { BODY, CARD_TITLE, META } from '@/lib/typography'
import { cn } from '@/lib/utils'

const NOT_FOUND_JOKE = 'Sprawdziliśmy dwa razy. Za drugim też nie było.'

/**
 * Nothing matched.
 *
 * Two ways out, and the second one matters more than it looks: a search that
 * found nothing is the clearest signal on the site that someone wants a piece
 * of equipment FLOU does not list, so the page asks rather than apologising.
 */
export function RentalEmptyState({
  query,
  onReset,
  locale,
}: {
  query: string
  onReset: () => void
  locale: string
}) {
  const searched = query.trim()

  return (
    <div className={cn('mt-6 p-8 text-center sm:p-10', RADIUS.feature, SURFACE)}>
      <p className="text-[2.4rem] leading-none" aria-hidden="true">
        🔦
      </p>
      <p className={cn(CARD_TITLE, 'mt-4 text-white')}>
        {searched ? <>Nie mamy „{searched}”.</> : 'Nic nie pasuje do wybranych filtrów.'}
      </p>
      <p className={cn(BODY, 'mx-auto mt-2 max-w-md text-white/60')}>
        {searched ? NOT_FOUND_JOKE : 'Odznacz kilka kategorii i spróbuj jeszcze raz.'}
      </p>

      <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <button
          type="button"
          onClick={onReset}
          className={cn(
            META,
            'inline-flex min-h-11 items-center rounded-full border border-white/15 bg-white/[0.05] px-5 font-semibold text-white/85 transition-colors hover:bg-white/[0.09] hover:text-white',
          )}
        >
          Wyczyść filtry
        </button>
        <Link
          href={`/${locale}/kontakt`}
          className={cn(
            META,
            'inline-flex min-h-11 items-center rounded-full bg-white px-5 font-semibold text-neutral-900 transition-colors duration-200 hover:bg-white/90',
          )}
        >
          Zapytaj, czy zdobędziemy
        </Link>
      </div>
    </div>
  )
}
